//actions
export const TOKEN_UPDATE = 'tokenUpdate';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const GET_TOKEN = 'getToken';
